import { useQuery } from '@tanstack/react-query';
import { portalDb, type PortalEstimateRow } from './portalClient';

export function usePortalEstimates(companyId: string | undefined) {
  return useQuery({
    queryKey: ['portal', companyId, 'estimates'],
    enabled: !!companyId,
    staleTime: 60_000,
    queryFn: async (): Promise<PortalEstimateRow[]> => {
      const { data, error } = await portalDb
        .from('portal_estimates')
        .select('*')
        .eq('company_id', companyId)
        .order('created_at', { ascending: false })
        .limit(200);
      if (error) throw error;
      return (data ?? []) as PortalEstimateRow[];
    },
  });
}

/** staleTime 0: coming back from the sign page must show the new status. */
export function usePortalEstimate(companyId: string | undefined, estimateId: string | undefined) {
  return useQuery({
    queryKey: ['portal', companyId, 'estimates', estimateId],
    enabled: !!companyId && !!estimateId,
    staleTime: 0,
    queryFn: async (): Promise<PortalEstimateRow | null> => {
      const { data, error } = await portalDb
        .from('portal_estimates')
        .select('*')
        .eq('company_id', companyId)
        .eq('id', estimateId)
        .maybeSingle();
      if (error) throw error;
      return (data as PortalEstimateRow | null) ?? null;
    },
  });
}
